module.exports = __webpack_public_path__ + "static/media/head.217f07da.png";